import { createAction } from 'redux-actions';

export const uploadAwtFileRequest = createAction('UPLOAD_AWT_FILE_REQUEST');
export const uploadAwtFileSuccess = createAction('UPLOAD_AWT_FILE_SUCCESS');
export const uploadAwtFileFail = createAction('UPLOAD_AWT_FILE_FAIL');
